export default class Compass {
  constructor(container) {
    if (!container) return

    console.log( 'Compass', container )

    // DOM
    this.DOM = {
      container,
      schema: container.querySelector('.compass__schema'),
      popups: [...container.querySelectorAll('.compass-popup')],
      allPopupsOpeners: [...container.querySelectorAll('.popup-opener')],
      closeButtons: [...container.querySelectorAll('.compass-popup__inner__close')]
    }

    console.log('Compass - Popups found:', this.DOM.popups.length)
    console.log('Compass - Openers found:', this.DOM.allPopupsOpeners.length)
    console.log('Compass - Close buttons found:', this.DOM.closeButtons.length)

    if (!this.DOM.popups.length) {
      console.warn('Compass - No popups found, cannot initialize')
      return
    }

    if (!this.DOM.allPopupsOpeners.length) {
      console.warn('Compass - No popup openers found, cannot initialize')
      return
    }

    // Settings
    this.currentOpener = null
    this.currentPopup = null
    this.schemaClassName = '--show-popup'
    
    this.createHitAreas()
    this.addEventListeners()
  }

  addEventListeners() {
    this.openPopup = this.openPopup.bind(this)
    this.closePopup = this.closePopup.bind(this)

    console.log('Compass - Attaching event listeners to', this.DOM.allPopupsOpeners.length, 'openers')
    this.DOM.allPopupsOpeners.forEach((opener, index) => {
      console.log(`Compass - Opener ${index}:`, opener, 'UUID:', opener.dataset.uuid)
      opener.addEventListener('click', this.openPopup)
    })
    
    console.log('Compass - Attaching event listeners to', this.DOM.closeButtons.length, 'close buttons')
    this.DOM.closeButtons.forEach(button => button.addEventListener('click', this.closePopup))
    
    console.log('Compass - Event listeners attached successfully')
  }

  createHitAreas() {
    const svgNamespace = 'http://www.w3.org/2000/svg'

    console.log('Compass - Creating hit areas for', this.DOM.allPopupsOpeners.length, 'openers')
    
    this.DOM.allPopupsOpeners.forEach((opener, index) => {
      if (opener.querySelector('[data-hit-area="true"]')) {
        console.log(`Compass - Opener ${index} already has hit area`)
        return
      }

      const bbox = opener.getBBox?.()

      if (!bbox || !bbox.width || !bbox.height) {
        console.warn(`Compass - Opener ${index} has no valid bounding box`)
        return
      }

      const padding = 6
      const rect = document.createElementNS(svgNamespace, 'rect')

      rect.setAttribute('x', bbox.x - padding)
      rect.setAttribute('y', bbox.y - padding)
      rect.setAttribute('width', bbox.width + padding * 2)
      rect.setAttribute('height', bbox.height + padding * 2)
      rect.setAttribute('fill', 'transparent')
      rect.setAttribute('data-hit-area', 'true')
      rect.style.cursor = 'pointer'
      rect.style.pointerEvents = 'all'

      opener.insertBefore(rect, opener.firstChild)
      console.log(`Compass - Hit area created for opener ${index}`)
    })
    
    console.log('Compass - Hit areas creation completed')
  }

  openPopup(event) {
    event?.preventDefault()

    // Get the current popup opener
    this.currentOpener = event.currentTarget

    console.log('Compass - Opening popup for opener:', this.currentOpener)
    console.log('Compass - Opener UUID:', this.currentOpener.dataset.uuid)

    // Get the current popup
    this.currentPopup = this.DOM.popups.find(popup => popup.dataset.uuid === this.currentOpener.dataset.uuid)
    
    if (!this.currentPopup) {
      console.error('Compass - Popup not found for UUID:', this.currentOpener.dataset.uuid)
      console.log('Compass - Available popups:', this.DOM.popups.map(p => p.dataset.uuid))
      return
    }
    
    console.log('Compass - Found popup:', this.currentPopup)

    // Remove active class from all popups and openers
    this.DOM.popups.forEach(popup => popup.classList.remove('is--active'))
    this.DOM.allPopupsOpeners.forEach(opener => opener.classList.remove('is--active'))

    // Add active class to the current popup and opener
    this.currentPopup.classList.add('is--active')

    // Add active class to the current opener
    this.currentOpener.classList.add('is--active')

    // Add active class to the schema
    Array.from(this.DOM.container.classList)
      .filter(className => className.startsWith('show--'))
      .forEach(className => this.DOM.container.classList.remove(className))
    this.DOM.container.classList.add(this.schemaClassName)
    this.DOM.container.classList.add(`show--${this.currentOpener.dataset.uuid}`)

    console.log('Compass - Popup opened successfully')
  }

  closePopup(event) {
    event?.preventDefault()

    if (!this.currentPopup || !this.currentOpener) return

    // Remove active class from the current popup and opener
    this.currentPopup.classList.remove('is--active')

    // Remove active class from the current opener
    this.currentOpener.classList.remove('is--active')

    // Remove active class from the schema
    this.DOM.container.classList.remove(this.schemaClassName)
    this.DOM.container.classList.remove(`show--${this.currentOpener.dataset.uuid}`)
    Array.from(this.DOM.container.classList)
      .filter(className => className.startsWith('show--'))
      .forEach(className => this.DOM.container.classList.remove(className))

    // Reset current popup and opener
    this.currentPopup = null
    this.currentOpener = null
  }

  destroy() {
    if (!this.DOM.allPopupsOpeners.length || !this.DOM.closeButtons.length) return

    this.DOM.allPopupsOpeners.forEach(opener => opener.removeEventListener('click', this.openPopup))
    this.DOM.closeButtons.forEach(button => button.removeEventListener('click', this.closePopup))

    this.currentOpener = null
    this.currentPopup = null
    this.schemaClassName = null

    this.DOM = null

    this.openPopup = null
    this.closePopup = null
  }
}